// extracted by mini-css-extract-plugin
module.exports = {"root":"SavedSearchListItem_root__1X039","name":"SavedSearchListItem_name__3aD9B","date":"SavedSearchListItem_date__20gRA"};